import { Stack, Typography } from "@mui/material";
import { Handle, Position } from "@xyflow/react";

import type { AssignmentRuleNode, RuleNodeProps } from "../types/nodes";
import { getAssignmentValueDisplayLabel } from "../utils/assignment-statement-display-utils";
import { useRuleScreenFieldDisplay } from "./rule-screen-field-display-context";
import BaseNode from "./BaseNode";

type AssignmentNodeProps = RuleNodeProps<AssignmentRuleNode>;

const AssignmentNode = (props: AssignmentNodeProps) => {
	const { data } = props;
	const statements = data.statements ?? [];
	const screenFieldDisplay = useRuleScreenFieldDisplay();

	return (
		<BaseNode {...props}>
			{statements.length ? (
				<Stack spacing={1}>
					{statements.map((statement, index) => {
						const key = statement.id ?? statement.variable ?? statement.operator ?? index;
						const variable = statement.variable ?? "Variable";
						const rawOp = statement.operator;
						const operator =
              typeof rawOp === "string"
              	? rawOp
              	: rawOp && typeof rawOp === "object" && rawOp !== null && "operator" in rawOp
              		? String((rawOp as { operator?: unknown }).operator ?? "=")
              		: "=";
						const valueLabel =
							getAssignmentValueDisplayLabel(
								statement,
								undefined,
								screenFieldDisplay?.currentScreenFieldIds,
							) || "—";

						return (
							<Stack key={key} direction="row" spacing={0.5} alignItems="baseline" flexWrap="wrap">
								<Typography variant="caption" color="text.disabled">
									{index + 1}.
								</Typography>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									{variable} {operator} {valueLabel}
								</Typography>
							</Stack>
						);
					})}
				</Stack>
			) : (
				<Typography variant="body2" color="text.disabled">
          No assignments configured
				</Typography>
			)}
			<Handle type="target" position={Position.Top} id="in" />
		</BaseNode>
	);
};

export default AssignmentNode;
